import { API_BASE_URL, API_CDN_URL } from "configs/AppConfig";

export const api_base_url = API_BASE_URL + "/api";
export const api_cdn_url = API_CDN_URL + "/api";

export const API_URL = {
  login: api_base_url + "/login",
  profile: api_base_url + "/auth/profile",
  changePassword: api_base_url + "/auth/change-password",

  dashboard: api_base_url + "/dashboard",
  inbox: api_base_url + "/surat/masuk",
  outbox: api_base_url + "/surat/keluar",

  // Settings
  fasilitatif: api_base_url + "/master/fasilitatif",
  archiveCode: api_base_url + "/master/kode-arsip",
  satker: api_base_url + "/master/satker",
  user: api_base_url + "/master/manajemen-akun",
  integrasi: api_base_url + "/master/integrasi",

  rekap: api_base_url + "/rekap",
  select: api_base_url + "/select",

  // Uploader

  upload: api_cdn_url + "/upload",
};
